import React from "react";
import { Wrapper } from "../../../components/Control/Flexbox";
import Input from "../../../components/Control/Input";

const style = {
  backgroundColor: "#fafafa",
  padding: "1rem",
  paddingBottom: "1.1rem",
  textAlign: "center",
  margin: 0,
};
const CreateRequestMethod = ({ requestData, handleChangeRequest }) => {
  return (
    <>
      <hr />
      <Wrapper
        style={{
          marginLeft: "0.5rem",
          alignItems: "start",
          justifyContent: "center",
        }}
        column
      >
        <Wrapper style={{ marginTop: "0.5rem" }}>
          <p
            style={{
              ...style,
              width: "192px",
            }}
          >
            METHOD
          </p>
          <p
            style={{
              ...style,
              width: "595px",
              marginLeft: "1.2rem",
            }}
          >
            Inspection Method Change
          </p>
          <Input
            type="text"
            name="meth_change_1"
            style={{ marginLeft: "0.8rem" }}
            onBlur={handleChangeRequest}
            defaultValue={requestData.meth_change_1}
          />
          <Input
            type="text"
            name="meth_reason_1"
            onBlur={handleChangeRequest}
            defaultValue={requestData.meth_reason_1}
          />
        </Wrapper>
        <Wrapper style={{ marginTop: "-0.5rem" }}>
          <p
            style={{
              ...style,
              width: "192px",
            }}
          >
            METHOD
          </p>
          <p
            style={{
              ...style,
              width: "595px",
              marginLeft: "1.2rem",
            }}
          >
            Process Parameter/ Layout Change
          </p>
          <Input
            type="text"
            name="meth_change_2"
            style={{ marginLeft: "0.8rem" }}
            onBlur={handleChangeRequest}
            defaultValue={requestData.meth_change_2}
          />
          <Input
            type="text"
            name="meth_reason_2"
            onBlur={handleChangeRequest}
            defaultValue={requestData.meth_reason_2}
          />
        </Wrapper>
        <Wrapper style={{ marginTop: "-0.5rem" }}>
          <p
            style={{
              ...style,
              width: "192px",
            }}
          >
            METHOD
          </p>
          <p
            style={{
              ...style,
              width: "595px",
              marginLeft: "1.2rem",
            }}
          >
            Process add, remove or process no change
          </p>
          <Input
            type="text"
            name="meth_change_3"
            style={{ marginLeft: "0.8rem" }}
            onBlur={handleChangeRequest}
            defaultValue={requestData.meth_change_3}
          />
          <Input
            type="text"
            name="meth_reason_3"
            onBlur={handleChangeRequest}
            defaultValue={requestData.meth_reason_3}
          />
        </Wrapper>
        <Wrapper style={{ marginTop: "-0.5rem" }}>
          <p
            style={{
              ...style,
              width: "192px",
            }}
          >
            METHOD
          </p>
          <p
            style={{
              ...style,
              width: "595px",
              marginLeft: "1.2rem",
            }}
          >
            Inspection Equipment failure
          </p>
          <Input
            type="text"
            name="meth_change_4"
            style={{ marginLeft: "0.8rem" }}
            onBlur={handleChangeRequest}
            defaultValue={requestData.meth_change_4}
          />
          <Input
            type="text"
            name="meth_reason_4"
            onBlur={handleChangeRequest}
            defaultValue={requestData.meth_reason_4}
          />
        </Wrapper>
        <Wrapper style={{ marginTop: "-0.5rem" }}>
          <p
            style={{
              ...style,
              width: "192px",
            }}
          >
            METHOD
          </p>
          <p
            style={{
              ...style,
              width: "595px",
              marginLeft: "1.2rem",
            }}
          >
            Part Fall down on floor from Bins / Trolley
          </p>
          <Input
            type="text"
            name="meth_change_5"
            style={{ marginLeft: "0.8rem" }}
            onBlur={handleChangeRequest}
            defaultValue={requestData.meth_change_5}
          />
          <Input
            type="text"
            name="meth_reason_5"
            onBlur={handleChangeRequest}
            defaultValue={requestData.meth_reason_5}
          />
        </Wrapper>
        <Wrapper style={{ marginTop: "-0.5rem" }}>
          <p
            style={{
              ...style,
              width: "192px",
            }}
          >
            METHOD
          </p>
          <p
            style={{
              ...style,
              width: "595px",
              marginLeft: "1.2rem",
            }}
          >
            Parts Mixing
          </p>
          <Input
            type="text"
            name="meth_change_6"
            style={{ marginLeft: "0.8rem" }}
            onBlur={handleChangeRequest}
            defaultValue={requestData.meth_change_6}
          />
          <Input
            type="text"
            name="meth_reason_6"
            onBlur={handleChangeRequest}
            defaultValue={requestData.meth_reason_6}
          />
        </Wrapper>
      </Wrapper>
    </>
  );
};

export default CreateRequestMethod;
